module.exports = __webpack_public_path__ + "static/media/thumbnail-kabeltarto-hid-acelszerkezet.11023e3f.jpg";